<template>
  <div class="message-banner-bar">
<!--    <img class="message-logo" :src="`${$imagePathBase}logo-red-carpet.svg`"/>-->
    <slot></slot>
    <router-link class="membership-details-link" to="/membership">
      <img :src="`${$imagePathBase}logo-red-carpet.svg`"/> Learn More<sup><i class="fa fa-external-link"></i></sup>
    </router-link>
  </div>
</template>


<script>
export default {
  name: "MessageBannerBar"
}
</script>


<style>
* {
  --mol-membership-banner-bar-height: 50px;
}
</style>


<style scoped>
.message-banner-bar {
  z-index: 1000;
  position: fixed;
  height: var(--mol-membership-banner-bar-height);
  width: 100%;
  background-color: var(--mol-color-red-carpet-background);
  border-style: none none solid none;
  border-color: var(--mol-color-red-carpet);
  border-width: 0.1px;


  text-align: center;
  font-size: 14px;

  padding: 0.225em;
  color: var(--mol-color-red-carpet);
  /*align-content: center;*/

  .message-logo {
    opacity: 10%;
    position: absolute;
    top: 10px;
    left: 10px;
    height: 50px;
  }

  .membership-details-link {

    display: block;

    color: inherit;
    text-decoration: inherit;
    font-size: 90%;
    font-weight: 500;

    img {
      height: 1.5em;
    }

    .fa-external-link {
      margin-left: 0.2em;
    }

    &:hover {
      color: var(--bs-link-hover-color);
    }
  }
}

</style>